// Screen-reader announcements for messages that arrive while the chat is open.
// The region (.chat-announcer in Inbox/MessageThread/index.html.twig) is a polite
// log: every line appended to it is read once. The initial list and older pages
// loaded on scroll are never passed here.

// Lines kept in the region; older ones were read already and only add noise
// when a screen reader browses the page.
const KEPT_LINES = 3;

const findRegion = () => document.querySelector<HTMLElement>("#conversation .chat-announcer");

const announce = (region: HTMLElement, text: string) => {
  const line = text.trim();

  if (line === "") {
    return;
  }

  const element = document.createElement("p");
  element.textContent = line;
  region.append(element);

  while (region.childElementCount > KEPT_LINES) {
    region.firstElementChild?.remove();
  }
};

/** The warning a possible scam message carries, without its "Learn more" link. */
const spamWarningOf = (message: HTMLElement): string => {
  const warning = message.querySelector(".spam-warning")?.cloneNode(true) as
    | HTMLElement
    | undefined;

  if (!warning) {
    return "";
  }

  for (const link of warning.querySelectorAll("a")) {
    link.remove();
  }

  return (warning.textContent ?? "").replace(/\s+/g, " ").trim();
};

/**
 * A message from the other member, read as "Name: text", with the warning a
 * possible scam message shows sighted members.
 */
export const announceReceivedMessage = (messagesWrapper: HTMLElement, messageId: number) => {
  const region = findRegion();
  const message = messagesWrapper.querySelector<HTMLElement>(
    `.message-container.user2[data-id='${messageId}']`,
  );
  const content = message?.querySelector<HTMLElement>(".message-content");

  if (!region || !message || !content) {
    return;
  }

  const sender = region.dataset.otherFirstName ?? "";
  // innerText keeps the line breaks of <br>, where textContent runs lines together.
  const text = content.innerText || content.textContent || "";

  announce(region, [sender ? `${sender}: ${text}` : text, spamWarningOf(message)].join(" "));
};

/** The member's own message, once it is in the list: "Delivered". */
export const announceSentMessage = () => {
  const region = findRegion();

  if (region) {
    announce(region, region.dataset.sentLabel ?? "");
  }
};
